import React, { useState, useEffect, /*useRef*/ } from 'react';
import {Button } from "reactstrap";
import Navbar from '../Navbar/Navbar';
import Footer from "../Footer/Footer";

import { useParams } from "react-router-dom";

import './Forms.css';
// import parse from 'html-react-parser';

import Swal from 'sweetalert2'

import * as Hosts from '../../../Hosts';
import {
    set_language,
    //reqGET,
	reqPOST,
    /*repo_banner_link,*/
    content_language,
    passwordHash

} from '../../../Utils';


import { language } from '../WEBContent/Language';
import Loader from '../../../loader';


const RecoveryForm = (props) => {

    const { hash } = useParams();

    const [lang, set_lang] = useState('pt');
    const [/*lang_id*/, set_lang_id] = useState('1');
    const [/*data*/, /*setData*/] = useState([]); 
    
    const [password_new, set_password_new] = useState(''); 
    const [password_conf, set_password_conf] = useState(''); 
    const [isloading, setLoading] = useState(true);

    const [dados_config, set_dados_config] = useState({});
    const [dados_navbar, set_dados_navbar] = useState({});

    /*let getInfo = async () => {

        reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/7`)
            .then(res => { 
                setData(res.data)
                //console.log(res.data)

            })
            .catch(erro => alert('Erro'))  

    }*/

    useEffect(() => { 
        //getInfo()
        
        //console.log('######################################')
        //console.log('######################################')

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        let getConfig = async () => {

            if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                set_dados_navbar(props.dados_navbar)
            }
        
            if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                set_dados_config(props.dados_config)
            }
    
            /*await reqGET(`${Hosts.SIMCore_API}/web/settings/type/${Hosts.companycode}/settings`)
                .then(async res => {
        
                if(res.data.length > 0) {
                    set_dados_config(dados_config.current = res.data[0].info?.settings)
                }
        
                })
                .catch(erro => console.log('Erro', erro))*/
        }

        (async () => {
            await getConfig()
      
            setLoading(false)
        })()
    
    }, [props]); 

    const handleSubmit = async e => {
        e.preventDefault();

        if(password_new !== password_conf) {
            Swal.fire(language[lang].confirmation_password_error_message, '', 'error')
        }
        else {

            reqPOST(Hosts.SIMCore_API + '/entities/password/recovery', {companycode: Hosts.companycode, recovery_hash: hash, new_password: passwordHash(password_new)})
                .then(res => {
                    console.log(res)
  
                    if(res.status === 200) {
                        set_password_new('')
                        set_password_conf('')
                        
                        Swal.fire(language[lang].change_password_sucess_message, '', 'info')
                    }
                    else {
                        Swal.fire(language[lang].change_password_expiration_message, '', 'error')
                    }
                    
            
                })
                .catch(() => 404)
        }
    }
        
    return(
        isloading ?

            <Loader />

        :
            <>

                <Navbar dados_config={dados_config} dados_navbar={dados_navbar} />
                <section id="recovery" className="py-5">
                    <div className="container">
                        <div className='row'>
                            <div className='col-12 title-properties'>
                                <h3 className="titulo-pp">
                                    {language[lang].contact_recovery}
                                </h3>
                                <hr></hr>
                            </div>
                            <div className='col-12 col-md-8 col-lg-6 mx-auto'>
                                <form onSubmit={handleSubmit}>
                                    <div className="row gy-3">
                                        <div className="col-12 col-md-6">
                                            <label className="form-label" htmlFor="password_new">{language[lang].password_new}*</label>
                                            <input id="password_new" type="password" name="password_new" value={password_new} className="form-control" placeholder={language[lang].password_placeholder}  onChange={(e) => set_password_new(e.target.value)} required />
                                        </div>                            
                                        <div className="col-12 col-md-6">
                                            <label className="form-label" htmlFor="password_conf">{language[lang].password_conf}*</label>
                                            <input id="password_conf" type="password" name="password_conf" value={password_conf} className="form-control" placeholder={language[lang].password_conf_placeholder} onChange={(e) => set_password_conf(e.target.value)} required />
                                        </div>
                                        <div className="col-12 mt-4">
                                            <Button color="primary">{language[lang].send}</Button>     
                                        </div> 
                                    </div>                             

                                </form>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer dados_config={dados_config} dados_navbar={dados_navbar} />
                
            </>
    );


};

export default RecoveryForm;